export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterSection {
  title: string;
  links: FooterLink[];
}

export interface ContactInfo {
  type: 'email' | 'phone';
  value: string;
  href: string;
  icon?: string;
}

export interface AddressInfo {
  title: string;
  address: string;
  phone?: string;
}

export const footerData = {
  aboutUs: {
    title: 'About Us',
    links: [
      { label: 'Home', href: '/' },
      { label: 'What We Do', href: '/what-we-do' },
      { label: 'Who We Are', href: '/who-we-are' },
      { label: 'Connect With Us', href: '/contact-us' },
      { label: 'Donate', href: '/donate' },
    ],
  },
  extraLinks: {
    title: 'Extra Links',
    links: [
      { label: 'Terms & Condition', href: '/terms-conditions' },
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Disclaimer', href: '/disclaimer' },
    ],
  },
  contactInfo: {
    title: 'Contact Us',
    contacts: [
      {
        type: 'email' as const,
        value: 'info@seedsimpact.org',
        href: 'mailto:info@seedsimpact.org',
      },
      {
        type: 'phone' as const,
        value: '+91-9963334436',
        href: 'tel:+9963334436',
      },
    ],
  },
  addresses: {
    registered: {
      title: 'Our Registered Address',
      address:
        'Social Empowerment and Economic Development Society, D-114, Okhla Phase I, New Delhi - 110020.',
    },
    centreOfExcellence: {
      title: 'Our Centre of Excellence',
      address:
        'SEEDS Campus, Rachavaripalli Road, Duttalur Village and Mandal, SPSR Nellore District, Andhra Pradesh.',
      phone: '+91-9848351236',
    },
  },
  socialLinks: [
    {
      platform: 'Facebook',
      href: 'https://www.facebook.com/SeedsImpactIndia?_rdr',
      icon: 'FacebookIcon',
    },
    {
      platform: 'Instagram',
      href: 'https://instagram.com/seedsimpact',
      icon: 'InstagramIcon',
    },
    {
      platform: 'LinkedIn',
      href: 'https://www.linkedin.com/company/social-empowerment-and-economic-development-society-seeds/',
      icon: 'LinkedinIcon',
    },
  ],
  aboutContent:
    'Driving change through impactful interventions in education, skills, sustainable farming, and healthcare for underserved communities across India.',
  copyright: '© 2026 Seedsimpact. All Rights Reserved.',
};
